export function deleteIncome(budget: Budget, income: RecordEntry): Budget {
  const initial = budget.initial - income.amount;
  return {...budget, initial};
}
